module.exports = __webpack_public_path__ + "img/logo-okuma.png";